import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {concat, Observable, of, Subject} from "rxjs";
import {Amphur, FileUpload} from "../../../../generated-model/model";
import {NgSelectComponent} from "@ng-select/ng-select";
import {HttpClient} from "@angular/common/http";
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from "rxjs/operators";
import {IgnoreNullHttpParams} from "../../Ignore-null-http-params";
import {untilDestroyed} from "ngx-take-until-destroy";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'gt-amphur-autocomplete',
  templateUrl: './gt-amphur-autocomplete.component.html',
  styleUrls: ['./gt-amphur-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: GtAmphurAutocompleteComponent,
      multi: true
    }
  ],
})
export class GtAmphurAutocompleteComponent implements ControlValueAccessor, OnInit {

  @Input()
  id: string;
  @Input()
  name: string;
  @Input()
  validateField: string;
  @Input()
  readonly: boolean = false;

  amphurList$: Observable<Amphur[]>;
  term$ = new Subject<string>();
  typeaheadLoading = false;
  _value: any | FileUpload = undefined;

  @ViewChild("amphurSelect", {static: true})
  amphurSelect: NgSelectComponent;

  onChangeCallBack: (_: any) => void = () => {
  };
  onTouchCallBack: () => void = () => {
  };

  constructor(private _http: HttpClient) {
  }

  ngOnInit(): void {

    this.amphurList$ = concat(
      of([]), // default items
      this.term$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => this.typeaheadLoading = true),
        switchMap(term => {
          return this.search(term)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => this.typeaheadLoading = false),
              untilDestroyed(this)
            );
        })
      )
    );
  }

  registerOnChange(fn: any): void {
    this.onChangeCallBack = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchCallBack = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  onModelChange(item: string) {

    this.value = item;
  }

  search(term: string): Observable<Amphur[]> {

    return this._http.get<Amphur[]>(`public/api/amphur/th/search`,
      {params: IgnoreNullHttpParams.fromObject({term: term}).toHttpParam()}
    );
  }

  public clear() {

    this.amphurSelect.handleClearClick();
    this.amphurSelect.blur();
  }

  onSelectOpen() {

    this.term$.next('');
  }

  set value(val: any) {

    this._value = val;
    this.onChangeCallBack(val);
    this.onTouchCallBack();
  }

  get value(): any {

    return this._value;
  }

  ngOnDestroy(): void {

  }
}
